import { CodeBlock } from 'scoobie';

import { useGraphQLPlayground } from './graphqlPlayground.tsx';

const LABEL_REGEX = /label="([^"]+)"/;

const toDefault = (meta?: string): boolean =>
  Boolean(meta?.replace(LABEL_REGEX, '').match(/(^|\s)default(\s|$)/));

const toLabel = (meta?: string): string | undefined =>
  meta?.match(LABEL_REGEX)?.[1];

/**
 * MDAST node as passed through by the `mergeCodeBlocks` Remark plugin.
 *
 * {@link https://github.com/syntax-tree/mdast/blob/main/readme.md#code}
 */
interface MdastCode {
  lang?: string;
  meta?: string;
  value: string;
}

const toCodeChildProps = (node: MdastCode) => ({
  code: node.value,
  label: toLabel(node.meta),
  language: node.lang ?? undefined,
});

interface Props {
  children: string;
  className?: string;
  meta?: string;
}

export const MdxCodeBlock = ({ children, className, meta }: Props) => {
  const graphqlPlayground = useGraphQLPlayground();

  if (className === 'language-scoobie-merged-code' && meta) {
    const data = JSON.parse(meta) as MdastCode[];

    const firstDefaultIndex = data.findIndex((child) => toDefault(child.meta));

    const initialIndex = firstDefaultIndex === -1 ? 0 : firstDefaultIndex;

    return (
      <CodeBlock
        graphqlPlayground={graphqlPlayground}
        initialIndex={initialIndex}
      >
        {data.map(toCodeChildProps)}
      </CodeBlock>
    );
  }

  return (
    <CodeBlock
      graphqlPlayground={graphqlPlayground}
      label={toLabel(meta)}
      language={className?.replace(/^language-/, '')}
    >
      {String(children)}
    </CodeBlock>
  );
};
